import { render, staticRenderFns } from "./AddExpenseTypes.vue?vue&type=template&id=48e43dbb"
import script from "./AddExpenseTypes.vue?vue&type=script&lang=js"
export * from "./AddExpenseTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports